import { Component, Inject, Input, OnChanges, SimpleChanges } from "@angular/core";
import { Router } from "@angular/router";
import { HttpClient } from "@angular/common/http";
import { AppComponent } from "../app/app.component";
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';

@Component({
    selector: "witness",
    template: require('./witness.component.html'),
    styles: [require('./witness.component.css')]
})
export class WitnessComponent implements OnChanges {

    report: CollisionReport;
    //witness: Witness;
    witness: Witness = <Witness>{};
    WitnessWasWitness_req :string = "";

    constructor(private appcomponent: AppComponent, private http: HttpClient,
        @Inject('BASE_URL') private baseUrl: string,
        private router: Router, private spinnerService: Ng4LoadingSpinnerService) {
        this.report = appcomponent.getReport();
        if (this.report.CollisionReportUniqueId == null) {
            this.reportGetSync();
            this.router.navigate([this.router.url])
        }
        //if (this.report.FiveDigitCode == null || this.report.FiveDigitCode == 0) {
        //    this.router.navigate(["home"]);
        //}
        if (this.report.IsNew) {
            this.router.navigate(["home"]);
        }
        if (this.report.WitnessPersons == null || this.report.WitnessPersons.length == 0)
            this.report.WitnessPersons = [];
        this.witness = <Witness>{};
        document.body.scrollTop = 0;
    }

    ngOnChanges(changes: SimpleChanges) {
        if (typeof changes['report'] !== "undefined") {
            // retrieve the report variable change info
            var change = changes['report'];
            // only perform the task if the value has been changed
            if (!change.isFirstChange()) {
                // execute the Http request and retrieve the result
                //DO SOmething
            }
        }
        else
            console.log("Undefined");
    }
    onBack(): void {
        this.BackAndPost("otherdriver");
    }
    private BackAndPost(page: string): void {

        this.report.CurrentPage = page;
      //  this.appcomponent.setReport(this.report);
        this.router.navigate([page]);
    }

    onPhoneInput(): void {
        var phone = this.witness.WitnessPhone.replace(/[^0-9]/g, "")
        var v = phone.replace(/(\d{3})(\d{3})(\d{4})/, "($1) $2-$3");
        this.witness.WitnessPhone = v;
    }
    
    onAddWitness(): void {

        if (this.witness.WitnessPhone != null && this.witness.WitnessPhone != '' &&
            (this.witness.WitnessPhone.length != 14 ||
            this.witness.WitnessPhone.indexOf('(') == -1 ||
            this.witness.WitnessPhone.indexOf(')') == -1 ||
            this.witness.WitnessPhone.indexOf('-') == -1
            )) {
            alert("Phone number not in the correct format.");
            return;
        }

        if (this.Isvalid()) {
            this.witness.WitnessIndex = this.report.WitnessPersons.length + 1;
            this.witness.CollisionReportId = this.report.CollisionReportId;

            this.witness.WitnessId = Math.floor(Math.random() * 100000);
            this.report.WitnessPersons.push(this.witness);
            this.witness = <Witness>{};
            window.scrollTo(0, 0);
                
            this.onWasWitnessStatus('NO');
        }
    }

    onCancelAddWitness(): void {
        this.onWasWitnessStatus('NO');
    }

    onSelectWitness(witness: Witness): void {
        this.witness = <Witness>{};
        this.witness = witness;
    }
    onDeleteWitness(witness: Witness): void {
        if (confirm("Do you really want to delete this witness?")) {
            for (var i = 0; i < this.report.WitnessPersons.length; i++) {
                if (this.report.WitnessPersons[i].WitnessIndex == witness.WitnessIndex) {
                    if (this.report.WitnessPersons[i].WitnessId > 0) {
                        this.report.WitnessPersons.splice(i, 1);     
                    }
                    else
                    this.report.WitnessPersons.splice(i, 1);
                    break;
                }
            }
        }

    }
    onEditWitness(): void {
        if (this.Isvalid()) {
            for (var i = 0; i < this.report.WitnessPersons.length; i++) {
                if (this.report.WitnessPersons[i].WitnessIndex == this.witness.WitnessIndex) {
                    var url = this.baseUrl + "api/report/UpdateWittness";
                    this.spinnerService.show();
                    this.http
                        .post(url, this.witness)
                        .subscribe(res => {
                            var v = res as Witness;
                            this.witness = v;
                            this.report.WitnessPersons[i] = this.witness;
                            this.witness = <Witness>{};
                           
                        }, error => console.log(error), () => this.spinnerService.hide());
                    
                    break;
                }
            }
        }
    }
    onCancelWitness(): void {
        this.witness = <Witness>{};
    }
    onWasWitnessStatus(status: string): void {
        this.report.WitnessWasWitness = status;
    }

    onSubmit(): void {
        //   alert('SUCCESS!! :-)\n\n' + JSON.stringify(this.report));
        //if (this.report.EntityType != null && (this.report.EntityType == "PEDESTRIAN")) {
        //    this.ValidateAndPost("vehicledriverlocation");
        //}
        //else
        //this.ValidateAndPost("involved");

        //GO TO NEXT PAGE
        this.ValidateAndPost("vehicledriverlocation");
    }

    private ValidateAndPost(page: string) {
        this.report.IsWitnessPageValid = true;
        //if (this.report.WitnessWasWitness == "YES")
        //    this.report.WitnessPersons.push(this.witness);
        this.report.CurrentPage = page;
        this.appcomponent.setReport(this.report);
        this.router.navigate([page]);
        //GO TO NEXT PAGE
        //  this.router.navigate([page]);

    }


    private Isvalid(): boolean {

        if (this.report.WitnessWasWitness == null) {
            alert("Please select if there was a witnees or not.");
            return false;
        }
        if (this.witness.WitnessLastName == null || this.witness.WitnessLastName.trim().length == 0) {
                return false;
            }

       return true;
    }

    reportGetSync(): void {
        var url = this.baseUrl + "api/report";
        this.http
            .get(url)
            .toPromise().then(result => {
                var v = result as CollisionReport;
                if (typeof v.EntityType == 'undefined' || v.EntityType == null || v.EntityType == "") {
                    this.router.navigate(["home"]);
                }
                this.report = v;
            });
    }
}